import {
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { SectionKeys, Tabs } from "../../../_constants/individualFields.constant";
import DynamicQuestionWrapper from "../../../components/DynamicQuestion/DynamicQuestionWrapper";
import CommercialDescription from "./CommercialDescription";
import { grey } from "@mui/material/colors";
import { useSelector } from "react-redux";

const GeneralDetails = () => {
  const { t } = useTranslation();
  const { allFields } = useSelector(state => state.individualField.initialFieldsList); 
  const generalFields = useMemo(
    () =>
      allFields.filter(
        (field) => field.fieldDisplayPosition === `${Tabs.CHOSEN_OPTIONS}.${SectionKeys.GENERAL}`
      ),
    [allFields]
  );

  return (
    <>
      <Typography
        variant="h6"
        sx={{
            px: 2,
            py: 1.5
        }}>
        {t('taskAutomation.generalSettings')}
      </Typography>
      <Divider sx={{
          my: 0
      }} />
       <Grid container sx={{py: 1}} spacing={{ xs: 2, md: 0 }}>
          <Grid size={{ xs: 12, sm: 6, md: 6 }} sx={{ borderRight: { xs: "none", sm: `1px dashed ${grey[200]}` } }}>
            <Grid container spacing={1} sx={{ px: 2,mb: 2}}>
              <Grid size={{ xs: 12}}>
                <Typography variant="body1">{t("general.general")}</Typography>
              </Grid>
              <Grid size={{ xs: 12}}>
                <Divider sx={{
                  my: 0
                }} />
              </Grid>
            </Grid>
            <DynamicQuestionWrapper questions={generalFields} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <CommercialDescription  />
          </Grid>
      </Grid>
    </>
  );
};

export default GeneralDetails;
